import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartComponent } from './chart/chart.component';
import { ColumnSelectModule } from './column-select/column-select.module';
import { DialogModule } from './dialog/dialog.module';
import { FiltroTablaModule } from './filtro-tabla/filtro-tabla.module';
import { MaterialModule } from './material.module';
import { PolygonDrawModule } from './polygon-draw/polygon-draw.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChangelogModule } from './changelog/changelog.module';
import { TextareaModule } from './textarea/module';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { MarkerLocationModule } from './marker-location/marker-location.module';
import { UploadImageModule } from './upload-image/upload-image.module';
import { AutocompleteDireccionModule } from './autocomplete-direccion/autocomplete-direccion.module';
import { NgxColorsModule } from 'ngx-colors';
import { provideHttpClient } from '@angular/common/http';
import { MapaDisplayComponent } from './mapbox/mapa-display/mapa-display.component';
import { MapaPickerComponent } from './mapbox/mapa-picker/mapa-picker.component';

@NgModule({
  imports: [
    CommonModule,
    TooltipDirective,
    ChartComponent,
    MapaDisplayComponent,
    MapaPickerComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DragDropModule,
    NgSelectModule,
    TooltipDirective,
    MapaDisplayComponent,
    MapaPickerComponent,
    //
    MaterialModule,
    ColumnSelectModule,
    DialogModule,
    FiltroTablaModule,
    PolygonDrawModule,
    ChartComponent,
    ChangelogModule,
    TextareaModule,
    MarkerLocationModule,
    UploadImageModule,
    AutocompleteDireccionModule,
    NgxColorsModule,
  ],
  providers: [provideHttpClient()],
})
export class AuxiliaresModule {}
